import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { registerLocaleData } from '@angular/common';
import esLocale from '@angular/common/locales/es';

registerLocaleData(esLocale);

bootstrapApplication(AppComponent, appConfig)
